export const SUCCESS_RESPONSE = "Success"
export const FAILED_RESPONSE = "Failed"

export const ModalTypeSuccess = 'Success'
export const ModalTypeFail = 'Fail'
export const ModalTypeLoading = 'Loading'
export const ModalTypeConfirmation = 'Confirmation'

export const ApiResponseSuccess = 1
export const APiResponseError = 0
export const ApiResponseStatusOk = 200
export const ApiResponseStatusNotFound = 400
export const ApiResponseStatusUnauthorized = 401
export const ApiResponseStatusInternalServerError = 500

export const StatusCodeActive = "1"
export const StatusCodeDelete = "2"

export const AxiosNetworkError = "ERR_NETWORK"

export const EmptyString = ""
export const Undefined = "undefined"
export const DefaultErrorMessage = "An error has occured. Please contact IT Support"

export const FormTypeAdd = "Add"
export const FormTypeEdit = "Edit"
export const FormTypeView = "View"

export const PageSize = 25
export const DownloadPageSize = 100000

export const PaginationFirst = "First"
export const PaginationBack = "Back"
export const PaginationNext = "Next"
export const PaginationLast = "Last"

export const DateNullDefault = "0001-01-01T00:00:00"

export const Active = "Active"
export const Deleted = "Deleted"

export const DateInsertFormat = "yyyy-MM-DD"
export const SmallDateFormat = "DD MMM yyyy"

export const SidebarOpen = "open"
export const SidebarClose = "close"

export const TransactionTypeSales = '1'
export const TransactionTypeRental = '2'

export const DropdownStatusList = [
    {label: "All", value: ""},
    {label: "Active", value: "1"},
    {label: "Delete", value: "2"}
]
export const DropdownPageSizeOptions = [
    {label: "25", value: "25"},
    {label: "50", value: "50"},
    {label: "100", value: "100"},
    {label: "All", value: ""}
]
export const DashboardDetailSizeOptions = [
    {label: "5", value: "5"},
    {label: "25", value: "25"},
    {label: "50", value: "50"},
    {label: "All", value: ""}
]
export const SalesStockStatusOptions = [
    {label: "All", value: ""},
    {label: "Available", value: "1"},
    {label: "Sold", value: "2"}
]
export const SalesStockGroupByOptions = [
    {label: "Stock", value: "1"},
    {label: "Product", value: "2"}
]
export const RentalStockStatusOptions = [
    {label: "All", value: ""},
    {label: "Available", value: "1"},
    {label: "Rented", value: "2"},
    {label: "Sold", value: "3"}
]
export const FilterPaymentTypeOptions = [
    {label: "All", value: ""},
    {label: "Cash", value: "1"},
    {label: "QRIS", value: "2"},
    {label: "Card", value: "3"},
    {label: "Transfer", value: "4"},
    {label: "Lainnya", value: "5"}
]
export const PaymentTypeOptions = [
    {label: "Cash", value: "1"},
    {label: "QRIS", value: "2"},
    {label: "Card", value: "3"},
    {label: "Transfer", value: "4"},
    {label: "Lainnya", value: "5"}
]
export const RentalOptions = [
    {label: "Session", value: "2"},
    {label: "Day", value: "3"}
]
export const RentalStatusOptions = [
    {label: "All", value: ""},
    {label: "Rented", value: "0"},
    {label: "Returned", value: "1"}
]
export const TransactionTypeOptions = [
    {label: "Sales", value: "1"},
    {label: "Rental", value: "2"}
]
export const DeliveryStatus = [
    {label: "Preparing", value: "1"},
    {label: "Delivered", value: "2"}
]
export const ReturnConditionOptions = [
    {label: "-", value: ""},
    {label: "Excellent", value: "1"},
    {label: "Good", value: "2"},
    {label: "Fair", value: "3"},
    {label: "Demaged", value: "4"}
]
export const ClothesSizeOptions = [
    {label: "S", value: "S"},
    {label: "M", value: "M"},
    {label: "L", value: "L"},
    {label: "XL", value: "XL"},
    {label: "XXL", value: "XXL"}
]
export const ShoesSizeOptions = [
    {label: "32", value: "32"},
    {label: "33", value: "33"},
    {label: "34", value: "34"},
    {label: "35", value: "35"},
    {label: "36", value: "36"},
    {label: "37", value: "37"},
    {label: "38", value: "38"},
    {label: "39", value: "39"},
    {label: "40", value: "40"},
    {label: "41", value: "41"},
    {label: "42", value: "42"},
    {label: "43", value: "43"},
    {label: "44", value: "44"}
]

export const DashboardPeriodeFilterOptions = [
    {label: "Daily", value: "1"},
    {label: "Monthly", value: "2"},
    {label: "Yearly", value: "3"},
    {label: "All Time", value: "4"}
]

export const MonthOptions = [
    {label: "Januari", value: "1"},
    {label: "Febuari", value: "2"},
    {label: "Maret", value: "3"},
    {label: "April", value: "4"},
    {label: "Mei", value: "5"},
    {label: "Juni", value: "6"},
    {label: "Juli", value: "7"},
    {label: "Agustus", value: "8"},
    {label: "September", value: "9"},
    {label: "Oktober", value: "10"},
    {label: "November", value: "11"},
    {label: "Desember", value: "12"}
]

export const AppDeploymentYear = '2026'

export const YearOptions = (() => {
    const startYear = Number(AppDeploymentYear);
    const currentYear = new Date().getFullYear();

    // Jika startYear > currentYear, hanya tampilkan startYear
    const endYear = Math.max(startYear, currentYear);

    return Array.from(
        { length: endYear - startYear + 1 },
        (_, index) => {
        const year = startYear + index;
        return {
            label: year.toString(),
            value: year.toString(),
        };
        }
    )
})()




